import React, { useState } from 'react';

import { useAuth } from '~/context/AuthContext';
import GoogleAuthenticationButton from '~/core/atoms/Buttons/Authentication/Google';
import CliveSketchAvatarBig from '~/core/iconComponents/special/CliveSketchAvatarBig';
import EmailPasswordForm from '~/core/molecules/EmailPasswordForm';

const errorText: Record<string, string> = {
  'Request failed with status code 429': 'Too many requests. Please try again later.',
  default: 'Login failed. Please try again.',
};

const Auth: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [authError, setAuthError] = useState('');

  const { signInWithEmail } = useAuth();

  const handleEmailPasswordSubmit = async (email: string, password: string) => {
    try {
      setIsLoading(true);
      setAuthError('');
      await signInWithEmail(email, password);
    } catch (err) {
      const message = err instanceof Error ? err.message : 'An unexpected error occurred';
      setAuthError(errorText[message] || errorText.default);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="__ROOT_AUTH_SCREEN__ bg-gradient-1 flex h-full items-center justify-center bg-cover">
      <div className="__CENTER_CONTAINER__ my-auto flex w-full max-w-5/6 flex-wrap-reverse items-center justify-evenly">
        <div className="__FORM_CONTAINER__ inline-flex w-lg flex-col rounded-2xl bg-white p-80">
          <div className="mt-80 flex h-full flex-col justify-center">
            <div className="text-grey-700 mb-16 text-4xl">Hi, I'm Clive,</div>
            <div className="text-grey-700 mb-80 text-4xl font-extralight">Your AI Assistant</div>
          </div>
          <div className="mb-32 font-bold text-black">Log in to start using me</div>
          <GoogleAuthenticationButton className="mb-40" />

          {/* Or divider */}
          <div className="mb-40 flex items-center">
            <div className="border-grey-300 flex-grow border-t"></div>
            <span className="text-grey-500 mx-16 text-sm">or</span>
            <div className="border-grey-300 flex-grow border-t"></div>
          </div>

          <EmailPasswordForm isLoading={isLoading} authError={authError} onSubmit={handleEmailPasswordSubmit} />
        </div>
        <div className="__CLIVE_AVATAR_CONTAINER__ m-40 inline-flex items-center justify-start">
          <CliveSketchAvatarBig className="w-[230px]" />
        </div>
      </div>
    </div>
  );
};

export default Auth;
